var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.1172,
    cy: 12,
    r: 11,
    fill: "#DA1F1F",
    stroke: "#DA1F1F",
    strokeWidth: 1.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.22808 11.9999L10.8947 15.6666L17.0059 8.33325",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxActive);
export default __webpack_public_path__ + "static/media/checkbox-active.ce2d244dc551078121dd1de739819f51.svg";
export { ForwardRef as ReactComponent };